// Ensures that the reducer is exhaustive and handles every action
// https://medium.com/@lennardschutter/exhaustive-reducers-with-typescript-aa7f9b888974

export const endReducer = <T>(state: T, _action: never) => state;
